import {useState, useEffect} from 'react';

import {PageFilter} from 'filters/types';

import {isCypressApp} from 'core/utils/cypress';
import {EnnablLogger} from 'utils/ennabl';

export const useCypressFilterOverride = (filter: PageFilter | undefined) => {
  const [override, setOverride] = useState(() => window.__CYPRESS_FILTER_OVERRIDE__);

  useEffect(() => {
    if (!isCypressApp()) {
      return;
    }

    const cast = new BroadcastChannel('cypress-filter-override');

    cast.addEventListener('message', () => {
      EnnablLogger.log('useCypressFilterOverride', {
        override: window.__CYPRESS_FILTER_OVERRIDE__,
      });
      setOverride(window.__CYPRESS_FILTER_OVERRIDE__);
    });

    return () => cast.close();
  }, []);

  return isCypressApp() ? override ?? filter : filter;
};

const onCypressApply = (filter: PageFilter) => {
  const cast = new BroadcastChannel('cypress-filter-override');
  window.__CYPRESS_FILTER_OVERRIDE__ = {...filter, storedId: 'cypress-override-id'};
  cast.postMessage('update');
  cast.close();
};

export const useCypressFilterApply = (onApply: (filter: PageFilter) => Promise<void>) => {
  return isCypressApp() ? onCypressApply : onApply;
};
